import React, { useEffect, useState } from "react";
import { Banner } from '../../components';
import { ClientsRow } from '../../components';
import { HeroIndustries } from '../../components';
import { imagesArray } from '../../sprites/Generic';
import { Loader } from '../../components';
import { IndustriesSpriteJpg } from '../../components';
import { IndustriesCarouselMenu } from '../../components';
import { VideoScrollAlone } from '../../components';
import { BaseUrl } from "../../config";

const LandingGenericContainer = (props) => {

  const boxesArray = [
    {
      title: "Highest Quality",
      text: "Our ultra-realistic real-time rendered 3D Digital Twins are compliant to the most stringent of industry standards and created through our patented pipeline methodologies."
    },
    {
      title: "Active Experience",
      text: "We bring the digital experience to the highest level, comparable to the real-world experience where users can fully engage with the environment, products, and assets."
    },
    {
      title: "Growth Acceleration",
      text: "Transform and boost your business and company towards a “digital culture” and enable yourself to experience the enhanced opportunities of the full digital ecosystem."
    }
  ];
  const imgHeroIndustries = require('../../assets/hero-generic.png');

  const sprites = imagesArray;
  const arrayLoad = [
    ...sprites
  ]
  const [listClients, setListClients] = useState([]);

  useEffect(() => {
    document.title = "Invrsion for Every Industry"
   
    fetch(`${BaseUrl}/page?key=invrsion&slug=generic`, {
      method: 'GET'
    })
    .then(response => {
      return response.json()
      
    }).then((res) => {
      setListClients(res.data.company.clients);
    })
    
    
  }, []);
  return (
    <React.Fragment>
      <HeroIndustries 
        title="Whatever your business, it’s time to accelerate."
        bgColor="linear-gradient(105.88deg, #7244E2 , #C8B5F8 )"
        img={imgHeroIndustries}
     />
     <IndustriesSpriteJpg 
        idScroll="2!" 
        title="How our Full Reality solutions fulfill your needs" 
        black="#220F51"
        boxesArray={boxesArray}
        imagesArray={sprites}
        iframeUrl="https://sketchfab.com/models/16a16d30b17d457ab2165cf37d974d23/embed?annotations_visible=0&amp;camera=0&amp;animation_autoplay=0&amp;autostart=0&amp;ui_controls=0&amp;ui_infos=0&amp;ui_inspector=0&amp;ui_stop=0&amp;ui_watermark=0&amp;ui_watermark_link=0&amp;preload=1&amp;scrollwheel=0&amp;sound_enable=0&amp;ui_animations=0&amp;ui_annotations=0&amp;ui_ar=0&amp;ui_fadeout=0&amp;ui_fullscreen=0&amp;ui_help=0&amp;ui_infos=0&amp;ui_inspector=0&amp;ui_settings=0&amp;ui_stop=0&amp;ui_theatre=0&amp;ui_vr=0&amp;ui_watermark=0&amp;pixel_budget=0"
      />
      <IndustriesCarouselMenu
        colorCTA="#7244E2"
        black="#220F51"
        slider={[0,1,2,3,4]}
        noMarginTop={true}
      >
        <h3 className="big--title" style={{color: '#091749'}}>
        We want to connect the digital and physical worlds
        </h3>
      </IndustriesCarouselMenu>
      <VideoScrollAlone
        idScroll="video-interio-02"
        video={require('../../assets/video/video-case-generic.mp4')} 
      />
      {
        listClients.length > 0 &&
        <ClientsRow 
          black="#220F51"
          title="Brands that are already on board and trust in Invrsion's solutions"
          arrayClients={listClients}/>
      }
      <Banner bgColor="#F0EAFF" text="Intrigued? Let’s have a chat." route="/reach-out" copyRoute="Reach out" black="#220F51"/>
      <Loader arrayLoad={arrayLoad} />
    </React.Fragment>
  );
};

export default LandingGenericContainer;
